module.exports = __webpack_public_path__ + "img/domain-04-mobile.687f7265.png";